/* import __COLOCATED_TEMPLATE__ from './trigger-select-item-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();